import React from 'react'
import {Table, TableBody, TableRow, TableCell, IconButton} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import OptionList from './OptionList'
import CloseIcon from '@material-ui/icons/Close'
import {useParams} from 'react-router'
import {normalizeFieldValues} from './util'

const FieldRow = ({data, selectedOptions = [], onChange}) => {
  const [open, setOpen] = React.useState(false)
  const [selectedField, setSelectedField] = React.useState('')
  const {group_id} = useParams()
  const refAnchorEl = React.useRef(null)

  const handleChange = (e, values) => {
    onChange(e, data.field_id, values)
  }

  const handleClickOpen = (e, field_id) => {
    setOpen(true)
    setSelectedField(field_id)
  }

  return (
    <TableRow>
      <TableCell style={{width: '60%'}} align="left" className="ap-typography ap-typography--sm">
        {data.field_name}
      </TableCell>
      <TableCell align="left" className="ap-typography ap-typography-sm ap-typography--gray">
        {selectedOptions.length === 0 && 'No Limits'}
        {selectedOptions.length !== 0 && (
          <div className={`option-list__tag`}>
            {selectedOptions.length}{' '}
            <IconButton
              onClick={e => onChange(e, data.field_id, [])}
              size="small"
              className={`ap-icon-button ap-icon-button--xs ap-icon-button--white`}
            >
              <CloseIcon />
            </IconButton>
          </div>
        )}
      </TableCell>
      <TableCell align="center" style={{width: 60}}>
        <IconButton
          size="sm"
          onClick={e => {
            handleClickOpen(e, data.field_id)
          }}
          ref={refAnchorEl}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
        <OptionList
          anchorEl={refAnchorEl.current}
          open={open}
          field_id={selectedField}
          onClose={() => setOpen(false)}
          data={normalizeFieldValues(data.field_type, data.values)}
          onChange={handleChange}
          values={selectedOptions}
        />
      </TableCell>
    </TableRow>
  )
}

export default FieldRow
